const ads = require('./ads')
const modals = require('./modals')
const header = require('./header')
const images = require('./images')
const incentives = require('./incentives')
const horizontalScroll = require('./horizontal-scroll')

module.exports = {
  ads,
  modals,
  header,
  images,
  horizontalScroll,
  incentives,
}
